export default __webpack_public_path__ + "static/media/IconTopicManagementActive.478d3d15.svg";